import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialItemUpdateState: Dtos.TrialItemUpdate & IRegistrationFormState = {
    id: null,
    trialItemId: null,
    active: null,
    display: null,
    trialItems: [],
    trialItemInstitutions: [],
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false
}

export interface ITrialItemUpdateReduxFormState {
    id: IFieldState<number>,
    trialItemId: IFieldState<number>,
    display: IFieldState<string>,
    active: IFieldState<boolean>,
    trialItems: IFieldState<Dtos.TrialItem[]>,
    trialItemInstitutions: IFieldState<Dtos.TrialItemInstitutionSummary[]>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>
}
